import { React , useState} from 'react'
import AddNewPatientRiskScore from './AddNewPatientRiskScore'

const PatientRiskScore = ({expandAll, data, setIsRecordSaved, ...props}) => {

  let { isViewAllowed,  IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenPatientRiskScore, setIsOpenPatientRiskScore] = useState(false);
  const [patientRiskScoreID, setPatientRiskScoreID] = useState();
    const [expandItems, setExpandItems] = useState(true);
  
    const handleToggleExpand = () => {
      setExpandItems(prev => !prev);
    }

  const AddPatientRiskScore = (ID) => {
    if(!isViewAllowed) return;
    setPatientRiskScoreID(ID)
    setIsOpenPatientRiskScore(prev => !prev);
  }
  const ClosePatientRiskScore = () => {
    setIsOpenPatientRiskScore(false)
  }

  let PopupScreen = "";
  if (isOpenPatientRiskScore) {
      PopupScreen = <AddNewPatientRiskScore isOpenPatientRiskScore={isOpenPatientRiskScore} patientRiskScoreID={patientRiskScoreID} onClose={ClosePatientRiskScore} patientID={props?.patientID} // onDeletePatientRiskScore={DeletePatientRiskScore} 
      setIsRecordSaved={setIsRecordSaved} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
      />
  }
  return (
    <>
    {PopupScreen}
    <div className='content-box '>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1'>
            <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Patient Risk Score</p>
            {data?.length === 0 && <i className={`icon-dash-plus fs-19 ${isViewAllowed ? '' : 'disable'}`}  onClick={() => AddPatientRiskScore(null)}></i>}
        </div>
        {expandItems &&
          expandAll &&
        (data?.length > 0 ?
          data.map(item => (
            <div className='d-flex align-items-center justify-content-between'>
                <p className={`text validate-color font-m cursor-pointer ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddPatientRiskScore(item.PatientRiskScoreID)}>{item.RiskType}</p>
                <p className='text'>{item?.Score}</p>
            </div>
          )) : <></>)}
    </div>
    </>
  )
}

export default PatientRiskScore